import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corPid',
      type: 'input',
      label: '主体ID',
      placeholder: '请输入主体ID'
    },
    {
      field: 'fromUser',
      type: 'input',
      label: '工作账号',
      placeholder: '请输入工作账号'
    },
    {
      field: 'usedBy',
      type: 'input',
      label: '使用人',
      placeholder: '请输入使用人'
    },
    {
      field: 'timeSlot',
      type: 'datepicker',
      label: '通话时间段',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          const sixMonthsAgo = new Date();
          sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
          return date.getTime() < sixMonthsAgo.getTime();
        }
      }
    },
    {
      field: 'sysDate',
      type: 'datepicker',
      label: '查询日期',
      otherOptions: {
        placeholder: '选择日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
